// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';
import { mobileStorage } from '@/native/storage';

const SUPABASE_URL = import.meta.env.VITE_SUPABASE_URL;
const SUPABASE_PUBLISHABLE_KEY = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY;

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY, {
  auth: {
    // Pinned to the original project ref so the front-door URL swap
    // (<slug>-api.bwe.one) does not invalidate existing sessions:
    // supabase-js derives the default storage key from the client's host,
    // and that host just changed.
    storageKey: 'sb-bfcuqfbrtzsbziatjsfz-auth-token',
    storage: mobileStorage,
    persistSession: true,
    autoRefreshToken: true,
    detectSessionInUrl: true,
  }
});
